import { callGet, callPost, callDelete, callPut } from "../integrations/calls";
import { REQ } from "../../libs/constants";

export const saveData = async (data, token) => {
  return await callPost(REQ.CARD.SAVE_DATA, data, token);
};

export const getDataByEnteredOn = async (enteredOn, shift, token) => {
  return await callGet(
    `${REQ.CARD.GET_DATA_BY_ENTEREDON}/${enteredOn}/${shift}`,
    token
  );
};

export const updateSale = async (data, token) => {
  return await callPut(`${REQ.CARD.UPDATE_SALE}/${data.id}`, data, token);
};

export const deleteSingleCardSale = async (id, token) => {
  return await callDelete(`${REQ.CARD.DELETE_SINGLE_SALE}/${id}`, {}, token);
};

export const deleteByDate = async (date, shift, token) => {
  return await callDelete(
    `${REQ.CARD.DELETE_BY_DATE}/${date}/${shift}`,
    {},
    token
  );
};

export const descCard = async (token) => {
  return await callGet(REQ.CARD.ORDER_BY_DESC, token);
};

export const ascCard = async (token) => {
  return await callGet(REQ.CARD.ORDER_BY_ASC, token);
};

export const oneDayPrevious = async (data, token) => {
  return await callPost(REQ.CARD.ONE_DAY_PRE, data, token);
};

export const oneDayNext = async (data, token) => {
  return await callPost(REQ.CARD.ONE_DAY_NEXT, data, token);
};
